import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Area, AreaCrudCreate } from "../models/area.model";
import { ResponsePackage } from "../models/util.model";
import { DtCrudCreate } from "../models/dt.model";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";

@Injectable({
    providedIn: 'root'
  })
export class AreaService {
    
    private pathApi: string;
    private headers = new HttpHeaders({'Content-Type': 'application/json'});

    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + "area/";
    }

    public getAllForSelect(utilityId: number | null = null) {
      if(utilityId) {
        return this.http.get<ResponsePackage<Area[]>>(`${this.pathApi}getAllForSelect/${utilityId}`,{headers: this.headers, observe: 'response'});
      }
      else {
        return this.http.get<ResponsePackage<Area[]>>(`${this.pathApi}getAllForSelect`,{headers: this.headers, observe: 'response'});
      }
    }

    getAll(dataIn: any): Observable<any> {
      return this.http.post(`${this.pathApi}getAll`, dataIn, {observe: 'response'});
    }

    save(area: AreaCrudCreate): Observable<any> {
      return this.http.post(`${this.pathApi}save`, area, {observe: 'response'});
    }

    saveCrud(dt: DtCrudCreate): Observable<any> {
      return this.http.post(`${this.pathApi}saveCrud`, dt, {
        observe: 'response',
      });
    }

    delete(id: number): Observable<any> {
      return this.http.delete(`${this.pathApi}delete/${id}`, {observe: 'response'});
    }

    getAllForOptions(utilityId: number | null = null) {
      if(utilityId) {
        return this.http.get<ResponsePackage<Area[]>>(`${this.pathApi}getAllForOptions/${utilityId}`,{headers: this.headers, observe: 'response'});
      }
      else {
        return this.http.get<ResponsePackage<Area[]>>(`${this.pathApi}getAllForOptions`,{headers: this.headers, observe: 'response'});
      }
    }
}